import styled from 'styled-components';

import { headerVariables } from '../../components/Header/HeaderStyle';

import { breakpoints, colors } from '../../ui/variables';

const main = {
  paddingTop: {
    iphone: headerVariables.main.height.iphone + 32,
  },
};

export const ExamsArchiveStyle = styled.main`
  background-color: ${colors.gray};
  box-sizing: border-box;
  min-height: 100vh;
  padding: ${main.paddingTop.iphone}px 0 20px;
  width: 100%;
  padding-left: 32px;

  @media (min-width: ${breakpoints.ipadLandscape.width}px) {
    padding-right: 32px;
  }

  .exams-archive-sort-filter-form {
    padding: 0 20px;
    margin-bottom: 32px;

    @media (min-width: ${breakpoints.ipad.width}px) {
      display: flex;
      flex-wrap: wrap;
    }

    @media (min-width: ${breakpoints.hd.width}px) {
      padding: 0;
    }

    .sort-filter-field-wrapper {
      @media (min-width: ${breakpoints.ipad.width}px) {
        flex-basis: 50%;
        flex-grow: 1;
      }

      &:nth-child(2n + 1) {
        @media (min-width: ${breakpoints.ipad.width}px) {
          padding-right: 8px;
        }

        &:nth-last-child(2) {
          @media (min-width: ${breakpoints.ipad.width}px) {
            margin-bottom: 0;
          }
        }
      }

      &:nth-child(2n + 2) {
        @media (min-width: ${breakpoints.ipad.width}px) {
          padding-left: 8px;
        }
      }

      &:not(:last-child) {
        margin-bottom: 16px;
      }
    }
  }

  .exam-report-list-pagination-wrapper {
    margin-top: 20px;
  }
`;
